"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceOptionAdapter = void 0;
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var source_adapter_1 = require("./source-adapter");
var source_path_adapter_1 = require("./source-path-adapter");
// @ts-ignore
var SourceOptionAdapter = /** @class */ (function (_super) {
    __extends(SourceOptionAdapter, _super);
    function SourceOptionAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SourceOptionAdapter.prototype, "parent", {
        get: function () {
            for (var parentVm = this.$parent.$parent, parentLevel = 1; parentVm != null; parentVm = parentVm.$parent, parentLevel += 1) {
                if ((0, source_adapter_1.isSourcePropertyAdapter)(parentVm.$source)) {
                    return parentVm.$source;
                }
            }
            throw new Error("Parent source not found!");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceOptionAdapter.prototype, "label", {
        get: function () {
            return this.parent.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceOptionAdapter.prototype, "displayValue", {
        get: function () {
            return (0, source_path_adapter_1.formatDisplayValue)(this.parent, this.value);
        },
        enumerable: false,
        configurable: true
    });
    SourceOptionAdapter.prototype.toString = function () {
        return "Option for Source['" + this.parent.property.path + "']";
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)(),
        __metadata("design:type", Object)
    ], SourceOptionAdapter.prototype, "value", void 0);
    SourceOptionAdapter = __decorate([
        vue_property_decorator_1.Component
    ], SourceOptionAdapter);
    return SourceOptionAdapter;
}(vue_1.default));
exports.SourceOptionAdapter = SourceOptionAdapter;
